import twitterRaw from './twitter-artworks.json';
import newWorkRaw from './new-work-artworks.json';

export interface Artwork {
  id: string;
  title: string;
  image: string;
  thumbnail?: string;
  description: string;
  date: string;
  tags: string[];
  tweetUrl?: string;
  source?: 'local' | 'twitter';
}

const twitterArtworks = twitterRaw as unknown as Artwork[];
const newWorkArtworks = newWorkRaw as unknown as Artwork[];

// Merge Twitter + public/new-work (local wins on duplicate id)
const byId = new Map<string, Artwork>();
for (const a of twitterArtworks) {
  if (!byId.has(a.id)) byId.set(a.id, a);
}
for (const a of newWorkArtworks) {
  byId.set(a.id, a);
}

export const artworks: Artwork[] = Array.from(byId.values()).sort(
  (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
);
